export default __webpack_public_path__ + "static/media/uploader-medtronic-4.57911a21.png";